import React from "react"
import styled from "styled-components"

// import NewsLetterForm from "components/forms/NewsLetterForm"

import { TextGroup } from "../common"

import { device } from "utils"

const PageTitleAndNewsLetter = ({ title, titleAs }) => {
  return (
    <NewsLetterWrap>
      <TextGroup title={title} titleAs={titleAs} />
      {/* <NewsLetterForm /> */}
    </NewsLetterWrap>
  )
}

const NewsLetterWrap = styled.div`
  margin-bottom: var(--sp-40);
  display: grid;
  grid-template-column: 1fr;
  grid-gap: var(--sp-8);
  align-items: center;
  width: 100%;

  @media ${device.laptop} {
    display: flex;
    justify-content: space-between;
  }

  .title {
    font-size: 2rem;

    @media ${device.laptop} {
      font-size: 3rem;
    }
  }
`

PageTitleAndNewsLetter.defaultProps = {
  title: "",
  titleAs: "h2",
}

export default PageTitleAndNewsLetter
